import { useState, useEffect } from "react";
import goFlyerAPI from "../apis/goflyer";
import convert from "xml-js";

const useGoResources = (resource) => {
  const [resources, setResources] = useState([]);

  const fetchResource = async (resource) => {
    //const res = await axios.get(`${process.env.REACT_APP_API}${resource}`);
    const res = await goFlyerAPI.get(
      `/detail?key=3oZrD6IfMtLIx8kwiKzc&id=19768`
    );

    if (res) {
      let xmlReply = convert.xml2js(res.data, {
        compact: true,
        spaces: 4,
      });

      setResources(xmlReply);
    }
  };

  useEffect(() => {
    fetchResource(resource);
  }, [resource]);

  return resources;
};

export default useGoResources;
